import { Input, Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
// import { SiteConfigService } from '../../../services/site-config.service';
// import { AppConfigService } from '../../../config/app-config.service';

@Component({
  selector: 'app-com-render',
  template: `<zc-loader *ngIf="showLoader"></zc-loader>
<ng-template *ngIf='options' dynamic-template (templateReady)="templateReady($event)" [context]='{options:options}'
    [template]="template" [lazyModules]="lazyModules">
</ng-template>`,
  styles: [``]
})
export class ComRenderComponent implements OnInit {

  @Input() data: any = {};
  @Input() type: string;
  @Input() properties: any = {}; // baseUrl http uid client
  options: any = {};
  lazyModules: any = [];
  template: string;
  uid: string;
  client: string;
  baseUrl: string;
  showLoader = true;
  constructor(private activatedRoute: ActivatedRoute,
    public http: HttpClient,
    @Inject(DOCUMENT) private document: any) {

  }

  ngOnInit() {
    Object.assign(this.options, this.data.definition);
    // this.options =  .data;
    if (this.properties) {
      if (this.properties.baseUrl) {
        this.options.baseUrl = this.properties.baseUrl;
        this.baseUrl = this.properties.baseUrl;
      }
      if (this.properties.http) {
        this.options.http = this.properties.http;
      }
      if (this.properties.uid) {
        this.options.uid = this.properties.uid;
      }
      if (this.properties.client) {
        this.client = this.properties.client;
      }
    }

    switch (this.type) {
      case 'form':
        this.lazyModules = ['zc-widget-form'];
        this.options.appStorageKey = this.client;
        this.options.apiUrl = this.baseUrl + this.options.apiUrl;
        this.options.fields = this.options.blocks;
        this.template = '<zc-widget-form [saveDataAlert]="true" [properties]="options"></zc-widget-form>';
        break;
      case 'zc-widget-multi-step-form':
        this.lazyModules = ['zc-widget-multi-step-form'];
        this.template = '<zc-widget-multi-step-form  [properties]="options"></zc-widget-multi-step-form>';
        break;
      case 'list':
        this.lazyModules = ['zc-widget-data-list'];
        this.options.apiUrl = this.baseUrl + this.options.apiUrl;
        this.options.appStorageKey = this.client;
        this.template = '<zc-widget-data-list [properties]="options"></zc-widget-data-list>';
        break;
      case 'login':
        this.lazyModules = ['zc-widget-login'];
        this.options.apiUrl = this.baseUrl + this.options.apiUrl;
        if (this.properties.logoPath) {
          this.options.logoPath = this.properties.logoPath;
        }
        this.options.appStorageKey = this.client;
        this.template = '<zc-widget-login [properties]="options"></zc-widget-login>';
        break;
      case 'html':
        this.lazyModules = [];
        this.template = this.options.template;
        break;
      case 'menu':
        this.lazyModules = ['slide-menu'];
        this.template = '<app-side-menu></app-side-menu>';
        break;
      case 'image':
        this.lazyModules = ['tss-image'];
        this.template = '<app-tss-image [options]="options"></app-tss-image>';
        break;
      case 'stage-form':
        this.lazyModules = ['zc-widget-stage-form'];
        this.options.appStorageKey = this.client;
        this.options.apiUrl = this.baseUrl + this.options.apiUrl;
        this.template = '<zc-widget-stage-form  [properties]="options"></zc-widget-stage-form >';
        break;
      case 'bar-chart':
      case 'info-chart':
      case 'pie-chart':
      case 'line-chart':
      case 'polar-chart':
        this.lazyModules = ['zc-widget-charts'];
        this.options.chartType = this.data.definition.chartType || this.data.info.type;
        this.template = '<zc-widget-charts  [properties]="options"></zc-widget-charts>';
        break;
      case 'tab-form':
        this.lazyModules = ['zc-widget-tab-form'];
        this.options.apiUrl = this.baseUrl + this.options.apiUrl;
        this.template = '<zc-widget-tab-form  [properties]="options"></zc-widget-tab-form >';
        break;
      default:
        this.lazyModules = [];
        this.template = 'oop! widget not found';
        break;
    }
  }
  templateReady(event) {
    this.showLoader = false;
    console.log('templateReady', event);
  }
}
